import React, { useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './LoginPage.css';

const GOOGLE_CLIENT_ID = '364894474586-8k09bj32alp14s4sudurom15p4qbqtna.apps.googleusercontent.com';

function LoginPage() {
    const navigate = useNavigate();

    const handleGoogleResponse = useCallback(async (response) => {
        try {
            const res = await fetch('/api/auth/google', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ credential: response.credential }),
            });
            const data = await res.json();

            if (data.Success) {
                localStorage.setItem('token', data.access_token);
                localStorage.setItem('user', JSON.stringify(data.user));
                navigate('/dashboard');
            } else {
                alert(data.Message || 'Login failed');
            }
        } catch (error) {
            alert('Connection error. Please try again.');
        }
    }, [navigate]);

    useEffect(() => {
        // Check if already logged in
        const token = localStorage.getItem('token');
        if (token) {
            navigate('/dashboard');
            return;
        }

        // Load Google Sign-In script
        const script = document.createElement('script');
        script.src = 'https://accounts.google.com/gsi/client';
        script.async = true;
        script.defer = true;
        script.onload = () => {
            if (window.google) {
                window.google.accounts.id.initialize({
                    client_id: GOOGLE_CLIENT_ID,
                    callback: handleGoogleResponse,
                    auto_select: false,
                });
                window.google.accounts.id.renderButton(
                    document.getElementById('google-signin-btn'),
                    {
                        theme: 'filled_black',
                        size: 'large',
                        width: 320,
                        text: 'signin_with',
                        shape: 'pill',
                    }
                );
            }
        };
        document.head.appendChild(script);

        return () => {
            const existing = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
            if (existing) existing.remove();
        };
    }, [navigate, handleGoogleResponse]);

    return (
        <div style={styles.page}>
            <link href="https://fonts.googleapis.com/icon?family=Material+Icons" rel="stylesheet" />
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800&display=swap" rel="stylesheet" />

            <div style={styles.container}>
                <div style={styles.logoContainer}>
                    <div style={styles.logoIcon}>
                        <span className="material-icons" style={{ fontSize: 36, color: '#3b82f6' }}>smart_toy</span>
                    </div>
                    <h1 style={styles.title}>GAM Assistant</h1>
                    <p style={styles.subtitle}>Google Workspace Admin Management</p>
                </div>

                <div style={styles.card}>
                    <h2 style={styles.cardTitle}>Sign in</h2>
                    <p style={styles.cardSubtitle}>Use your LEC Google account to continue</p>

                    <div id="google-signin-btn" style={styles.googleBtn}></div>

                    <div style={styles.divider}>
                        <span style={styles.dividerLine}></span>
                        <span style={styles.dividerText}>@lecfl.com accounts only</span>
                        <span style={styles.dividerLine}></span>
                    </div>
                </div>

                <p style={styles.footer}>
                    Contact admin for access if you don't have an account
                </p>
            </div>
        </div>
    );
}

const styles = {
    page: {
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#0a0f1a',
        fontFamily: "'Inter', -apple-system, sans-serif",
        padding: 20,
    },
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 24,
        maxWidth: 400,
        width: '100%',
    },
    logoContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 8,
    },
    logoIcon: {
        width: 72,
        height: 72,
        borderRadius: 20,
        background: 'linear-gradient(135deg, rgba(59,130,246,0.15), rgba(139,92,246,0.15))',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        border: '1px solid rgba(59,130,246,0.2)',
        marginBottom: 8,
    },
    title: {
        fontSize: 28,
        fontWeight: 800,
        color: '#f1f5f9',
        margin: 0,
        letterSpacing: '-0.5px',
    },
    subtitle: {
        fontSize: 14,
        color: '#64748b',
        margin: 0,
    },
    card: {
        width: '100%',
        backgroundColor: '#151d2e',
        borderRadius: 16,
        padding: '32px 28px',
        border: '1px solid rgba(255,255,255,0.06)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 20,
    },
    cardTitle: {
        fontSize: 20,
        fontWeight: 700,
        color: '#f1f5f9',
        margin: 0,
    },
    cardSubtitle: {
        fontSize: 14,
        color: '#94a3b8',
        margin: 0,
    },
    googleBtn: {
        display: 'flex',
        justifyContent: 'center',
        minHeight: 44,
    },
    divider: {
        display: 'flex',
        alignItems: 'center',
        gap: 12,
        width: '100%',
    },
    dividerLine: {
        flex: 1,
        height: 1,
        backgroundColor: 'rgba(255,255,255,0.06)',
    },
    dividerText: {
        fontSize: 11,
        color: '#475569',
        whiteSpace: 'nowrap',
    },
    footer: {
        fontSize: 12,
        color: '#334155',
        margin: 0,
    },
};

export default LoginPage;
